import React from 'react';
import {Link} from 'react-router-dom'
import moment from 'jalali-moment'
import { useProductSearch } from './../../queries/productSearch';

function ProductItem(props) {
    const productURL = `/product/${props.title.split(' ').join('-').toLocaleLowerCase()}?id=${props.id}`;
   

    const ItemWithAdvantage = props.product.productAdvantageList.contentItems.filter(i=> i.__typename !== "LabelForAdvantage" );
    const ItemWithImage = props.product.bag.contentItems.filter(i=> i.__typename === "ProductImage" );

    return (
        <div className={props.cols ? props.cols : 'col-md-6 col-lg-4'}>
            <div className="product-item">
                {
                    
                    // props.thumb ? (
                        <figure className="product-thumb">
                            {/* <Link to={`${process.env.PUBLIC_URL + productURL}`}> */}
                                <img src={process.env.REACT_APP_BASE_URL + ItemWithImage[0].productImage.urls[0]} alt={props.product.displayText} style={{width:"200px", margin:"0 30%"}}/>
                            {/* </Link> */}
                        </figure>
                    // ) : null
                }
                <div className="product-content" style={{padding:'2%', height:"200px"}}>
                    <div className="product-meta">
                        <h2 className="h5"><Link to={`${process.env.PUBLIC_URL + productURL}`}>{props.product.displayText}</Link></h2>
                        <ul>
                            <li>
                                {
                                    ItemWithAdvantage.map(adv => 
                                        <p style={{fontSize:"13px", justifyContent:"center", alignItems:"center", textAlign:"center", fontFamily:"MyShFont"}} dangerouslySetInnerHTML={{__html: adv.htmlBody.html}} />
                                    )
                                }
                                
                            </li>
                        </ul>
                    

                        {/* <Link to={`${process.env.PUBLIC_URL + productURL}`}>نویسنده: {props.postBy}</Link>
                        <Link to={`${process.env.PUBLIC_URL + productURL}`}>{moment(props.date, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}</Link> */}
                        <button style={{
                            width:'100px', 
                            height:"40px", 
                            backgroundColor:'red', 
                            border:'none', 
                            borderRadius:'20px', 
                            display:'flex', 
                            alignItems:"center", 
                            justifyContent:'center', 
                            color:"#fff", 
                            fontSize:"13px",
                            margin:"auto"
                            }}
                            >
                                <Link style={{color:"#fff"}} to={`${process.env.PUBLIC_URL + productURL}`}>اطلاعات بیشتر</Link></button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProductItem;
